export const locations = [
  {
    display: 'Austin, TX',
    value: 'infoAUS@diamondsdirect.com',
  },
  {
    display: 'Birmingham, AL',
    value: 'infoBHM@diamondsdirect.com',
  },
  {
    display: 'Boca Raton, FL',
    value: 'infoBOCA@diamondsdirect.com',
  },
  {
    display: 'Charleston, SC',
    value: 'infoCHS@diamondsdirect.com',
  },
  {
    display: 'Charlotte, NC',
    value: 'infoCLT@diamondsdirect.com',
  },
  {
    display: 'Cleveland, OH',
    value: 'infoCLE@diamondsdirect.com',
  },
  {
    display: 'Columbus, OH',
    value: 'infocol@diamondsdirect.com',
  },
  {
    display: 'Dallas, TX',
    value: 'infoDTX@diamondsdirect.com',
  },
  {
    display: 'Frisco, TX',
    value: 'infoFRISCO@diamondsdirect.com',
  },
  {
    display: 'Indianapolis, IN',
    value: 'infoindy@diamondsdirect.com',
  },
  {
    display: 'Jacksonville, FL',
    value: 'infojax@diamondsdirect.com',
  },
  {
    display: 'Kansas City, KS',
    value: 'infoKSC@diamondsdirect.com',
  },
  {
    display: 'New Orleans, LA',
    value: 'infoNOLA@diamondsdirect.com',
  },
  {
    display: 'Oklahoma City, OK',
    value: 'infoOKC@diamondsdirect.com',
  },
  {
    display: 'Raleigh, NC',
    value: 'infoRal@diamondsdirect.com',
  },
  {
    display: 'Richmond, VA',
    value: 'infoRic@diamondsdirect.com',
  },
  {
    display: 'St. Louis, MO',
    value: 'infostl@diamondsdirect.com',
  },
  {
    display: 'San Antonio, TX',
    value: 'infoSAT@diamondsdirect.com',
  },
  {
    display: 'Virginia Beach, VA',
    value: 'infoVAB@diamondsdirect.com',
  },
];



// WEBPACK FOOTER //
// ./src/constants/dropdown.jsx